module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '任务浏览'
    }
  }, [_c('div', {
    staticClass: "search-top"
  }, [_c('span', [_vm._v("任务类型")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.search.type),
      callback: function($$v) {
        _vm.$set(_vm.search, "type", $$v)
      },
      expression: "search.type"
    }
  }, _vm._l((_vm.taskTpl), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.tpl_name
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("任务状态")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.search.status),
      callback: function($$v) {
        _vm.$set(_vm.search, "status", $$v)
      },
      expression: "search.status"
    }
  }, _vm._l((_vm.task_status), function(text, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "value": key,
        "label": text
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("名称/编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "输入名称或编号"
    },
    model: {
      value: (_vm.search.text),
      callback: function($$v) {
        _vm.$set(_vm.search, "text", $$v)
      },
      expression: "search.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": function($event) {
        _vm.searchDoc(1)
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "back-list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("编号")]), _vm._v(" "), _c('div', [_vm._v("发布时间")]), _vm._v(" "), _c('div', [_vm._v("任务名称")]), _vm._v(" "), _c('div', [_vm._v("发布者")]), _vm._v(" "), _c('div', [_vm._v("接收者")]), _vm._v(" "), _c('div', [_vm._v("任务类型")]), _vm._v(" "), _c('div', [_vm._v("任务快币")]), _vm._v(" "), _c('div', [_vm._v("状态")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "text-blue",
      on: {
        "click": function($event) {
          _vm.showTask(item)
        }
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("placeholder")(item.release_time)))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.task_name
      }
    }, [_vm._v(_vm._s(item.task_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      class: {
        'text-blue': item.pub_user_name
      },
      attrs: {
        "title": item.pub_user_name
      },
      on: {
        "click": function($event) {
          _vm.showPerson(item.pub_user_id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.pub_user_name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      class: {
        'text-blue': item.sub_user_name
      },
      attrs: {
        "title": item.sub_user_name
      },
      on: {
        "click": function($event) {
          _vm.showPerson(item.sub_user_id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.sub_user_name || "暂无") + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.tpl_name
      }
    }, [_vm._v(_vm._s(item.tpl_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_amount))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.task_status[item.process_status]))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.data.current_page,
      "total": _vm.data.total,
      "page-size": _vm.data.per_page,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.searchDoc,
      "update:currentPage": function($event) {
        _vm.$set(_vm.data, "current_page", $event)
      }
    }
  }), _vm._v(" "), _c('z-windowPop', {
    attrs: {
      "show": _vm.pop.show,
      "height": '80%',
      "noBtns": true,
      "title": ("任务编号：" + (_vm.pop.title))
    },
    on: {
      "cancel": function($event) {
        _vm.pop.show = false
      }
    }
  }, [_c('readDetail', {
    attrs: {
      "taskId": _vm.pop.id,
      "prohibit": true
    }
  })], 1), _vm._v(" "), _c('personPop', {
    attrs: {
      "read": true,
      "id": _vm.person.id,
      "show": _vm.person.flag
    },
    on: {
      "close": function($event) {
        _vm.person.flag = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4da757f0!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/task/page-task-skim.vue
// module id = 742
// module chunks = 1